/**
 * Calendar Events - Interview and visit scheduling projections.
 */
import { z } from 'zod';
import { ApplicationCode, ApplicationId, ChildApplicationId } from '../types/branded';

export const CalendarEventType = z.enum(['interview', 'visit']);
export type CalendarEventType = z.infer<typeof CalendarEventType>;

export const CalendarEventSchema = z.object({
  id: z.string(),
  applicationId: ApplicationId,
  childApplicationId: ChildApplicationId.nullable().optional(),
  eventType: CalendarEventType,
  startDateTime: z.number().int(),
  endDateTime: z.number().int(),
  referenceCode: ApplicationCode.optional(),
  familyName: z.string().optional(),
});
export type CalendarEvent = z.infer<typeof CalendarEventSchema>;

export const CalendarEventFilterSchema = z.object({
  applicationId: ApplicationId.optional(),
  startDate: z.number().int().optional(),
  endDate: z.number().int().optional(),
  eventTypes: z.array(CalendarEventType).optional(),
});
export type CalendarEventFilter = z.infer<typeof CalendarEventFilterSchema>;
